import "./App.css";
import RoutesConfig from "./RoutesConfig";
import { UserInfoProvider } from "./common/user-context";
import AppHeader from "./header";
import { withOktaAuth } from "@okta/okta-react";
import { Component } from "react";
import { ThemeProvider } from "@deere/fuel-react";
import FomFooter from "./common/Footer/FomFooter";

class App extends Component {
  componentDidMount() {
    if (!this.props.authState.isAuthenticated) {
      this.props.authService.logout();
    }
  }

  render() {
    return (
      <ThemeProvider>
        <div className="wrapper">
          <div className="bg-gray">
            <AppHeader />
            <UserInfoProvider>
              <RoutesConfig />
            </UserInfoProvider>
          </div>
          <div className="footer">
            <FomFooter />
          </div>
        </div>
      </ThemeProvider>
    );
  }
}

export default withOktaAuth(App);
